import { render, staticRenderFns } from "./PolicyPublic.vue?vue&type=template&id=1329cc1a&scoped=true&"
import script from "./PolicyPublic.vue?vue&type=script&lang=js&"
export * from "./PolicyPublic.vue?vue&type=script&lang=js&"
import style0 from "./PolicyPublic.vue?vue&type=style&index=0&id=1329cc1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1329cc1a",
  null
  
)

export default component.exports